// Use public asset for logo
const logoImage = '/logo.png';

export function Logo({ className = "h-8" }: { className?: string }) {
  return (
    <img
      src={logoImage}
      alt="HelioROI"
      className={className}
    />
  );
}
